import ImageDashboard from "../../../../components/image-manager/ImageDashboard";

const HomeImages = () => {

    return (
        <ImageDashboard
            title="Home Page Images"
            api="/images/home"
            fetchEndpoint="/api/images/home"
            uploadEndpoint="/upload/home"
            reorderEndpoint="/api/images/home/image/reorder"
            renameEndpoint="/api/images/home/image/rename"
            deleteEndpointBase="/api/images/home/image"
            allowReorder={true}
        />
    )
}

export default HomeImages